var $ = require( 'jquery' );
var easing = require( 'jquery-easing');
/*
================================================================================
* javascript information
* file name  : utlilty.js (共有のスクリプト)
================================================================================
*/
$(function() {
    var topBtn = $('#page-top');    
    topBtn.hide();
    $(window).scroll(function () {
        if ($(this).scrollTop() > 100) {
            topBtn.fadeIn();
        } else {
            topBtn.fadeOut();
        }
    });
    topBtn.click(function () {
            $('body,html').animate({
            scrollTop: 0
        }, 500);
        return false;
    });
});
